module.exports = __webpack_public_path__ + "img/coindesk.02db0284.png";